import MyHeader from "../components/headerComponent.js";
import Navbar from "../components/nav.js";
import Gallery from "../components/gallery.jsx";
import SocialsBar from "../components/socialsBar.js";
import MyFooter from "../components/footerComponent.js";

// Import your local images
import image1 from '../images/gallery/1_Effiel_Tower_In_Fog_Paris_2010_wm.jpg';
import image2 from '../images/gallery/2_Fire_Garden_IF_Festival_Milton_Keynes_2012_wm.jpg';
import image3 from '../images/gallery/3_Bassist_The_Sugarmill_Stoke-On-Trent_2013_wm.jpg';
import image4 from '../images/gallery/4_Star_Trails_Peak_Distrcit_Staffordshire_2013_wm.jpg';
import image5 from '../images/gallery/5_Skateboarder_Nottingham_2018_wm.jpg';
import image6 from '../images/gallery/6_Steve_Stoke-On-Trent_2011_wm.jpg';
import image7 from '../images/gallery/7_The_Kiss_Yasmin_&_Rickys_Wedding_Milton_Keynes_2014_wm.jpg';
import image8 from '../images/gallery/8_Shoot_When_The_Stage_Lights_Flash_Novus_Exhibition_Stoke-On-Trent_2013_wm.jpg';
import image9 from '../images/gallery/9_Music_Runs_Deep_Nexus_Exhibition_Stoke-On-Trent_2014_wm.jpg';

const galleryImages = [
  { src: image1, caption: 'Eiffel Tower In Fog, Paris, 2010' },
  { src: image2, caption: 'Fire Garden, IF Festival, Milton Keynes, 2012' },
  { src: image3, caption: 'Bassist, The Sugarmill, Stoke-On-Trent, 2013' },
  { src: image4, caption: 'Star Trails, Peak District, Staffordshire, 2013' },
  { src: image5, caption: 'Skateboarder, Nottingham, 2018' },
  { src: image6, caption: 'Steve, Stoke-On-Trent, 2011' },
  { src: image7, caption: "The Kiss, Yasmin & Ricky's Wedding, Milton Keynes, 2014" },
  { src: image8, caption: 'Shoot When The Stage Lights Flash, Novus Exhibition, Stoke-On-Trent, 2013' },
  { src: image9, caption: 'Music Runs Deep, Nexus Exhibition, Stoke-On-Trent, 2014' },
];

function Photography() {

  return (
    <div className="Photography">
        <header>
            <MyHeader />
            <Navbar />
        </header>
        <main>
            <h2>Photography</h2>
            <Gallery galleryImages={galleryImages}/>
        </main>
        <footer>
            <SocialsBar />
            <MyFooter />
        </footer>
    </div>
  );
}

export default Photography;
